// extracted by mini-css-extract-plugin
export default {"container":"Curve_container__5mxdx","curve":"Curve_curve__OzOkx","white_curve":"Curve_white_curve__yW1o3","inner_container":"Curve_inner_container__-Y3xy"};